import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import LeftMenu from "../../../../Components/LeftMenu";
import Header from "../../../../Components/Header";
import ReactTable from "react-table";
import FranchiseApprovalMasterForm from "./FranchiseApprovalMasterForm";
import { FullScreenLoader } from "../../../../Components/Assets/Loader";
import { cloneDeep, fromPairs } from "lodash";
import { FranchiseApprovalList } from "../../../../Utils/Services/FranchiseAppraiser";
import "react-table/react-table.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure();

const initForm = {
  CaseStatus: "",
};

class FranchiseApprovalMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showModal: false,
      search: "",
      form: cloneDeep(initForm),
      appraiserData: [],
      appraiserContainer: [],
      verifyObj: "",
      status: "",
    };
  }

  componentDidMount = () => {
    this.getFranchiseAppraiser();
  };

  getFranchiseAppraiser = () => {
    this.setState({ loading: true });
    let obj = {
      status: "Approved_Pending_Rejected",
    };
    FranchiseApprovalList(obj).then((res) => {
      this.setState({ loading: false });
      if (res.error) {
        this.setState({ loading: false });

        return;
      }
      if (res.data.error) {
        toast.error(res.data.message, {
          type: toast.TYPE.ERROR,
          autoClose: 4000,
        });
        this.setState({ loading: false });
        return;
      } else {
        // console.log("res.data/.///", res.data);
        if (res.data && res.data.data && res.data.data.length > 0) {
          this.setState({
            appraiserData: res.data.data,
            appraiserContainer: res.data.data,
          });
        }
      }
    });
  };

  addAppraiserFranchise = (id, status) => {
    let { appraiserData } = this.state;
    console.log(appraiserData);
    let appraiserDataTemp = appraiserData.find(
      (appraiserData) => appraiserData.applicationnumber === id
    );
    console.log(appraiserDataTemp);

    this.setState({
      showModal: !this.state.showModal,
      verifyObj: appraiserDataTemp ? appraiserDataTemp.applicationnumber : null,
      status: status,
    });
  };
  search = (e) => {
    let { appraiserContainer } = this.state;
    let array = [];
    appraiserContainer.map((res) => {
      let name = res.franchiseCode;

      if (
        res.franchiseCode ||
        (res && res.companypan) ||
        (res && res.companyname) ||
        (res && res.emailid) ||
        (res && res.mobilenumber) ||
        (res.status && res.status) ||
        (res.updatedOn && res.updatedOn)
      )
        if (
          (res &&
            res.franchiseCode &&
            res.franchiseCode
              .toLowerCase()
              .match(
                e && e.target && e.target.value && e.target.value.toLowerCase()
              )) ||
          (res &&
            res.companypan &&
            res.companypan
              .toLowerCase()
              .match(
                e && e.target && e.target.value && e.target.value.toLowerCase()
              )) ||
          (res &&
            res.companyname &&
            res.companyname
              .toLowerCase()
              .match(
                e && e.target && e.target.value && e.target.value.toLowerCase()
              )) ||
          (res &&
            res.emailid &&
            res.emailid
              .toLowerCase()
              .match(
                e && e.target && e.target.value && e.target.value.toLowerCase()
              )) ||
          (res &&
            res.mobilenumber &&
            res.mobilenumber
              .toString()
              .toLowerCase()
              .match(
                e && e.target && e.target.value && e.target.value.toLowerCase()
              )) ||
          (res &&
            res.status &&
            res.status
              .toString()
              .toLowerCase()
              .match(
                e && e.target && e.target.value && e.target.value.toLowerCase()
              ))
        ) {
          array.push(res);
        }
    });
    this.setState({
      search: e.target.value,
      appraiserData: e.target.value ? array : appraiserContainer,
    });
  };

  render() {
    let { loading, showModal, appraiserData, verifyObj, status } = this.state;

    const columns = [
      {
        Header: "Application Number",

        Cell: ({ original }) => {
          return original.franchiseCode || "";
        },
      },
      {
        Header: "Company",

        Cell: ({ original }) => {
          return original.companyname || "";
        },
      },
      {
        Header: "Company Pan",

        Cell: ({ original }) => {
          return original.companypan || "";
        },
      },
      {
        Header: "Email Id",

        Cell: ({ original }) => {
          return original.emailid || "NA";
        },
      },
      {
        Header: "Mobile Number",

        Cell: ({ original }) => {
          return original.mobilenumber || "NA";
        },
      },
      {
        Header: "Status",

        Cell: ({ original }) => {
          return original.status || "";
        },
      },
      {
        Header: "Updated On",
        accessor: "updatedOn",

        Cell: ({ original }) => {
          return original.updatedOn || "";
        },
      },
      {
        Header: "Action",
        accessor: "edit",

        Cell: ({ original }) => {
          console.log(
            "original...",
            original && original.applicationnumber,
            original && original.status
          );
          return (
            <div disabled={false}>
              <i
                onClick={() =>
                  this.addAppraiserFranchise(
                    original && original.applicationnumber,
                    original && original.status
                  )
                }
                className="fas fa-user-edit"
                style={{ cursor: "pointer" }}
              />
            </div>
          );
        },
      },
    ];
    return (
      <div className="dash_grid">
        <FullScreenLoader />
        <LeftMenu role={this.props.role} />
        <main className="bg-white">
          <Header {...this.props} />
          <section className="container-fluid">
            <ToastContainer />
            <h5 className="text-center mt-5 mx-auto user-box">
              Franchise Approval Master
            </h5>
            {!loading ? (
              <React.Fragment>
                <div className="d-flex align-items-center mt-5">
                  <div className="form-group m-0 search-input">
                    <div className="inner-addon right-addon">
                      <i className="glyphicon glyphicon-search mt-1 font-size-20"></i>
                      <input
                        type="text"
                        className="form-input"
                        name="search"
                        placeholder="Search..."
                        onChange={this.search}
                      />
                    </div>
                  </div>
                </div>
                <div className={`mt-4 react-table`}>
                  <ReactTable
                    scroll={{ x: "max-content", y: 350 }}
                    data={appraiserData}
                    columns={columns}
                    defaultPageSize={10}
                    className="-striped -highlight"
                  />
                </div>
              </React.Fragment>
            ) : (
              <h4 className="text-center mt-5">LOADING...</h4>
            )}
            {showModal && (
              <FranchiseApprovalMasterForm
                addAppraiserFranchise={this.addAppraiserFranchise}
                verifyObj={verifyObj}
                status={status}
                fetchAppraiser={this.getFranchiseAppraiser}
              />
            )}
          </section>
        </main>
      </div>
    );
  }
}

export default withRouter(FranchiseApprovalMaster);
